<template>
	<div class="assignment-page-wrapper">
		<ProductContentAssignment :contentData="contentData" />
	</div>
</template>

<script>
import ProductContentAssignment from '../ProductContentDashboard/Content/Assignment.vue';

export default {
	name: "Assignment",
	props: { productVariantData: Object, contentData: Object },
	components: { ProductContentAssignment },
};
</script>

<style scoped>
.assignment-page-wrapper {
	max-width: 960px;
	margin: 24px auto;
	padding: 0 24px;
	width: 100%;
}
</style>
